import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";

export const ArticleCard = ({ article }) => (
  <Link
    to={`/knowledge/${article.slug}`}
    data-testid={`article-card-${article.slug}`}
    className="group flex flex-col rounded-3xl overflow-hidden border border-[#2A2A2A] bg-[#171717] transition-all duration-300 hover:border-[#1565FF]/60 hover:-translate-y-1"
  >
    <div className="relative aspect-[16/10] overflow-hidden">
      <img
        src={article.thumbnail}
        alt={article.title}
        className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition-opacity duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/50 to-transparent" />
      <div className="absolute top-4 left-4 label-mono text-white">{article.category}</div>
    </div>
    <div className="p-6 flex flex-col gap-4">
      <h3 className="text-white font-sans text-xl tracking-tight leading-tight">
        {article.title}
      </h3>
      <p className="text-[#B7BCC7] text-[13.5px] leading-relaxed line-clamp-3">
        {article.excerpt}
      </p>
      <div className="flex items-center justify-between border-t border-[#2A2A2A] pt-4 mt-1">
        <div className="text-[12px] text-[#6E7784]">
          <span className="text-white/80">{article.author}</span>
          <span className="mx-2">·</span>
          <span>{article.date}</span>
        </div>
        <div className="flex items-center gap-2 text-[12px] text-[#6E7784]">
          <Clock size={13} /> {article.reading_time}
          <ArrowUpRight size={14} className="ml-1 text-white group-hover:text-[#1565FF]" />
        </div>
      </div>
    </div>
  </Link>
);
